<template>
  <div class="chat-bubble" @mousedown.stop @contextmenu.prevent>
    <!-- <el-dropdown trigger="" ref="dropdown" v-if="!message.isRevoked" @command="handleCommand"> -->
    <div v-if="!message.isRevoked">
      <div class="hot_issues" :style="{ 'background': '#' + color }" v-if="message.evaluate_msg == 3">热门问题
        <!-- <i class="icon iconfont iconxiaoxi" style="margin-left: 8px; font-size: 14px;"></i> -->
        <img class="hot-title-bg" :src="hotTitleBg" alt="热门问题" />
      </div>
      <div class="message-content" :class="bubbleStyle" :style="message.type == 'location' ? { 'padding': '0' } : {}">
        <slot></slot>
        <img v-if="message.evaluate_msg == 3" class="hot-content-bg" :src="hotContentBg" alt="热门问题" />
      </div>
    </div>
    <!-- <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="revoke" v-if="isMine" :disabled='revokedDisabled'>撤回</el-dropdown-item>
        <el-dropdown-item command="copy" :disabled='copyDisabled'>复制</el-dropdown-item>
      </el-dropdown-menu> -->
    <!-- </el-dropdown> -->
    <div class="group-tip-element-wrapper" v-if="message.isRevoked">
      {{ text }}
      <el-button type="text" size="mini" class="edit-button" v-show="isEdit" @click="reEdit">&nbsp;重新编辑</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hotTitleBg from '@/assets/image/hot_title_bg.png'
import hotContentBg from '@/assets/image/hot_content_bg.png'
import TYPES from '@/utils/types'

export default {
  name: 'MessageBubble',
  data() {
    return {
      isTimeout: false,
      hotTitleBg,
      hotContentBg
      // copyDisabled :true
    }
  },
  props: {
    isMine: {
      type: Boolean
    },
    isNew: {
      type: Boolean
    },
    message: {
      type: Object,
      required: true
    }
  },
  created() {
    this.isTimeoutHandler()
  },
  mounted() {
    if (this.$refs.dropdown && this.$refs.dropdown.$el) {
      this.$refs.dropdown.$el.addEventListener('mousedown', this.handleDropDownMousedown)
    }
  },
  beforeDestroy() {
    if (this.$refs.dropdown && this.$refs.dropdown.$el) {
      this.$refs.dropdown.$el.removeEventListener('mousedown', this.handleDropDownMousedown)
    }
  },
  computed: {
    bubbleStyle() {
      let classString = ''
      if (this.isMine) {
        classString += 'message-send'
      } else {
        classString += 'message-received'
      }
      if (this.isNew) {
        classString += 'new'
      }
      if ((this.message.uniqueId && this.message.isFinished) || (this.message.isFinished == undefined && this.message.uniqueId) || (this.message.isRebotMsgFromHistory && this.message.type == TYPES.MSG_TYPE.MARKDOWN)) {
        classString += ' ' + 'has-action'
      }
      if (this.message.evaluate_msg == 3) {
        classString += ' ' + 'hot-issues'
      }
      return classString
    },
    text() {
      if (this.message.conversationType === this.TIM.TYPES.CONV_C2C && !this.isMine) {
        return '对方撤回了一条消息'
      }
      if (this.message.conversationType === this.TIM.TYPES.CONV_GROUP && !this.isMine) {
        return `${this.message.from}撤回了一条消息`
      }
      return '您撤回了一条消息'
    },
    isEdit() {
      if (!this.isMine) {
        return false
      }
      if (this.message.type !== 'text') {
        return false
      }
      if (this.isTimeout) {
        return false
      }
      return true
    },
    revokedDisabled() {
      if (parseInt((new Date()).getTime()) - this.message.createTime > 2 * 60 * 1000) {
        return true
      }
      return false
    },
    ...mapState({
      color: (state) => state.user.color,
    })
    // copyDisabled(){
    //   console.log(window.getSelection().toString())
    //   console.log(window.getSelection().toString()==="")
    //   return window.getSelection().toString()===""
    // }
  },
  methods: {
    handleDropDownMousedown(e) {
      if (!this.isMine || this.isTimeout) {
        return
      }
      if (e.buttons === 2) {
        if (this.$refs.dropdown.visible) {
          this.$refs.dropdown.hide()
        } else {
          this.$refs.dropdown.show()
        }
      }
    },
    handleCommand(command) {
      // return false
      let that = this
      switch (command) {
        case 'revoke':
          this.tim.getMessageList({ conversationID: this.message.conversationID, count: 15 }).then(function (imResponse) {
            let cur_message = []
            cur_message = imResponse.data.messageList.filter(item => {
              return item.ID === that.message.msg_id
            })
            if (cur_message.length == 1) {
              that.tim.revokeMessage(cur_message[0]).then(() => {
                that.$set(that.message, 'isRevoked', true)
                that.isTimeoutHandler()
              }).catch((err) => {
                that.$store.commit('showMessage', {
                  message: err,
                  type: 'warning'
                })
              })
            }
          })
          break
        case 'copy':
          break
        default:
          break
      }
    },
    isTimeoutHandler() { // 从发送消息时间开始算起，两分钟内可以编辑
      let now = new Date()
      if (this.message.time) {
        if (parseInt(now.getTime() / 1000) - this.message.time > 2 * 60) {
          this.isTimeout = true
          return
        }
      }
      setTimeout(this.isTimeoutHandler, 1000)
    },
    reEdit() {
      this.$bus.$emit('reEditMessage', this.message.payload.text)
    }
  }
}
</script>

<style lang="stylus" scoped>
.chat-bubble
  position relative;
  .hot_issues{
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #fff;
    height: 48px;
    line-height: 48px;
    padding-left: 12px;
    color: #1A1D25;
    position: relative;
    overflow: hidden;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .hot_issues::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #E9EAED;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }

  .hot-title-bg {
    position: absolute;
    width: 48px;
    left: 0;
    top: 0;
    transform: translate(-12px, -9px);
  }

  .hot-content-bg{
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(63px, 88px) rotate(10.68deg);
    
  }
  .message-status
    display: flex;
    margin: 10px 5px 0 0;
    justify-content: center;
    align-items: center;
    color: #007eed;
	.iconfont
    font-size 12px
	.iconyidu{color: #888}
  .message-content
    outline: none
    font-size:12px;/*no*/
    position relative
    max-width 700px
    word-wrap break-word
    word-break break-all
    padding 7px 12px;/*no*/
    font-size 14px
    line-height 22px
    overflow hidden
    @media screen and (max-width: 924px) {
      max-width 7.4667rem
    }

    a {
      color: #2290FD;
    }
    .follow-up-question{
      color: #2290FD;
    }

    span
      white-space pre-wrap
      margin 0
      // text-shadow $regular 0 0 0.05em
    img
      vertical-align bottom
    &::before
      position: absolute
      top: 4px
      width: 12px
      height: 32px
      content "\e654"
      font-family 'iconfont' !important
      font-size 24px // 32px 在mac上会模糊 24px正常 , window 24px模糊 28px 32px正常  36px windows mac 基本一致，但是太大  
  .message-received
    background-color $white
    border-radius: 6px
    min-height 32px 
    &::before
      left 0px
      transform scaleX(-1)
      color $white
    &.new
      transform: scale(0);
      transform-origin: top left;
      animation: bounce 500ms linear both;

  .has-action
    border-bottom-left-radius: 0
    border-bottom-right-radius: 0
    
  .has-action.message-received{
    border-bottom-left-radius 0
    border-bottom-right-radius 0
  }
  .hot-issues.message-received{
    border-top-left-radius 0
    border-top-right-radius 0
    padding-top 0
    max-width 100%
    padding 7px 0
  }
  .message-send
    background-color $blue-primary
    // margin-right 15px
    border-radius: 6px;
    color $white
    &::before
      right: 0px
      color $blue-primary
    &.new
      transform: scale(0);
      transform-origin: top right;
      animation: bounce 500ms linear both;
  .el-dropdown {
    vertical-align: top;
    display flex
  }
  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
.group-tip-element-wrapper
  background $white
  padding 4px 15px
  border-radius 3px
  color $secondary
  font-size 12px
  // text-shadow $secondary 0 0 0.05em
.edit-button
  padding-top 4px
  height 20px
  font-size 10px
@keyframes bounce {
  0% { transform: matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  4.7% { transform: matrix3d(0.45, 0, 0, 0, 0, 0.45, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  9.41% { transform: matrix3d(0.883, 0, 0, 0, 0, 0.883, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  14.11% { transform: matrix3d(1.141, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  18.72% { transform: matrix3d(1.212, 0, 0, 0, 0, 1.212, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  24.32% { transform: matrix3d(1.151, 0, 0, 0, 0, 1.151, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  29.93% { transform: matrix3d(1.048, 0, 0, 0, 0, 1.048, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  35.54% { transform: matrix3d(0.979, 0, 0, 0, 0, 0.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  41.04% { transform: matrix3d(0.961, 0, 0, 0, 0, 0.961, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  52.15% { transform: matrix3d(0.991, 0, 0, 0, 0, 0.991, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  63.26% { transform: matrix3d(1.007, 0, 0, 0, 0, 1.007, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  85.49% { transform: matrix3d(0.999, 0, 0, 0, 0, 0.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  100% { transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
}
</style>
